<template>
  <v-container grid-list-xs class="elevation-6 pa-0">
    <v-layout row wrap>
      <v-flex xs12 md5 class="border-right text-xs-center">
        <v-avatar size="175" color="blue darken-4" class="elevation-8 mt-5">
          <h1 class="display-4 white--text">{{ user.firstName.charAt(0) }}</h1>
        </v-avatar>
        <h3 class="headline mt-3">{{ user.firstName }} {{ user.lastName }}</h3>
        <h4 class="subheading mt-2">{{ user.type }}</h4>
      </v-flex>
      <v-flex xs12 md5 offset-md1>
        <PCForm :fields="fields" @save="save" class="pt-3 pb-3" />
      </v-flex>
      <v-snackbar v-model="snackbar.show" :bottom="true" :right="true">
        {{ snackbar.message }}
        <v-btn color="red" flat @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
    </v-layout>
    <AdView id="165" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AdView from "@/components/AdView";
import PCForm from "@/components/PCForm";
import { countryNames } from "@/countries";

export default {
  components: { AdView, PCForm },
  data() {
    return {
      fields: [
        {
          name: "First Name",
          type: "text",
          value: "",
          classes: ["pl-1", "xs12", "md6"],
        },
        {
          name: "Last Name",
          type: "text",
          value: "",
          classes: ["pl-1", "xs12", "md6"],
        },
        {
          name: "Type",
          type: "select",
          value: "",
          items: ["Pool Owner", "Pool Professional"],
          classes: ["pl-1", "xs12"],
        },
        {
          name: "Address",
          type: "text",
          value: "",
          classes: ["pl-1", "xs12"],
        },
        {
          name: "City",
          type: "text",
          value: "",
          classes: ["pl-1", "xs12", "md6"],
        },
        {
          name: "State/Province",
          type: "text",
          value: "",
          classes: ["pl-1", "xs12", "md6"],
        },
        {
          name: "Country",
          type: "select",
          value: "",
          items: countryNames,
          classes: ["pl-1", "xs12"],
        },
        {
          name: "Postal Code",
          type: "text",
          value: "",
          classes: ["pl-1", "xs12"],
        },
        {
          name: "Sign up for our Newsletter",
          type: "checkbox",
          value: false,
          classes: ["pl1", "xs12"],
        },
      ],
      snackbar: {
        show: false,
        message: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
  },
  methods: {
    ...mapActions({
      initUser: "user/initUser",
      saveUser: "user/saveUser",
    }),
    async save() {
      try {
        await this.saveUser({
          firstName: this.fields[0].value,
          lastName: this.fields[1].value,
          type: this.fields[2].value,
          address: this.fields[3].value,
          city: this.fields[4].value,
          state: this.fields[5].value,
          country: this.fields[6].value,
          postalCode: this.fields[7].value,
          newsletterSubscribed: this.fields[8].value,
        });
        this.snackbar = { show: true, message: "Profile saved successfully" };
      } catch (err) {
        this.snackbar = { show: true, message: err.message };
      }
    },
  },
  async mounted() {
    await this.initUser();
    this.fields[0].value = this.user.firstName || "";
    this.fields[1].value = this.user.lastName || "";
    this.fields[2].value = this.user.type || "";
    this.fields[3].value = this.user.address || "";
    this.fields[4].value = this.user.city || "";
    this.fields[5].value = this.user.state || "";
    this.fields[6].value = this.user.country || "";
    this.fields[7].value = this.user.postalCode | "";
    this.fields[8].value = this.user.newsletterSubscribed || false;
  },
};
</script>

<style lang="scss" scoped>
.border-right {
  border-right: 1px solid #d8d8d8;
}
</style>
